import logo from 'src/icons/SE_logo.png'
import {Box} from "@mui/system";

export const Logo = (props) => {
    let {height} = props
    return (
        <Box component="img"
             src={logo}
             alt="Logo"
             sx={{height: height ?? '100px'}}/>
    );
};
